/**
 * cuteReason movido para um arquivo, /src/data/CuteReasons
 *
 *
 */


import {FcmEvent} from '@common/FcmEvent';
import {Timestamp, firestore, analytics} from '@src/db';
import {FcmIndexedDB} from '@common/FcmIndexedDB';
// import {FcmTimer, delay} from '@common/TimeUtils';
import {delay} from '@common/TimeUtils';
import {eventHub} from '@src/eventHub';
import {UserType} from '@common/status';
import {getSearch} from '@common/StringUtils';
const _ = require('lodash');

const LIMIT_CACHE_DEV = 9000;
// v60: adicionado o cache `chartOfAccounts` (plano de contas por empresa) — rework do plano de contas.
const CACHE_DB_VERSION = 60;

export const getters = {
  getterActiveScrubNurses(state) {
    return state.users.filter(a=>(
      (a._companyUser.active && a._companyUser.type===UserType.KSCRUB_NURSE) ||
      (a._companyUserMatriz.active && a._companyUserMatriz.type===UserType.KSCRUB_NURSE)
    ));
  },
  getterActiveUsers(state) {
    return state.users.filter(a=>(
      a._companyUser.active ||
      a._companyUserMatriz.active
    ));
  },
  getterActiveAnesthetists(state) {
    return state.users.filter(a=>(
      (a._companyUser.active && a._companyUser.type===UserType.KANESTHETIST) ||
      (a._companyUserMatriz.active && a._companyUserMatriz.type===UserType.KANESTHETIST)
    ));
  },
  getterAnesthetists(state) {
    return state.users.filter(a=>(
      a._companyUser.type===UserType.KANESTHETIST ||
      a._companyUserMatriz.type===UserType.KANESTHETIST
    ));
  },
  getterActiveSurgeons(state) {
    return state.users.filter(a=>(
      (a._companyUser.active && a._companyUser.type===UserType.KSURGEON) ||
      (a._companyUserMatriz.active && a._companyUserMatriz.type===UserType.KSURGEON)
    ));
  },
  getterSurgeons(state) {
    return state.users.filter(a=>(
      a._companyUser.type===UserType.KSURGEON ||
      a._companyUserMatriz.type===UserType.KSURGEON
    ));
  },
  getterResidentAnesthetist(state) {
    return state.users.filter(a=>(
      a._companyUser.type===UserType.KRESIDENT_ANESTHETIST ||
      a._companyUserMatriz.type===UserType.KRESIDENT_ANESTHETIST
    ));
  },
  getterActiveResidentAnesthetist(state) {
    return state.users.filter(a=>(
      (a._companyUser.active && a._companyUser.type===UserType.KRESIDENT_ANESTHETIST) ||
      (a._companyUserMatriz.active && a._companyUserMatriz.type===UserType.KRESIDENT_ANESTHETIST)
    ));
  },
  getterActivePhonoaudiologist(state) {
    return state.users.filter(a=>(
      (a._companyUser.active && a._companyUser.type===UserType.KPHONOAUDIOLOGIST) ||
      (a._companyUserMatriz.active && a._companyUserMatriz.type===UserType.KPHONOAUDIOLOGIST)
    ));
  },
  getterPhonoaudiologist(state) {
    return state.users.filter(a=>(
      a._companyUser.type===UserType.KPHONOAUDIOLOGIST ||
      a._companyUserMatriz.type===UserType.KPHONOAUDIOLOGIST
    ));
  },
  getterActiveFiliais(state) {
    return state.filiais.filter(a=>a.active);
  },
  getterActiveAdminCompanies(state) {
    return state.adminCompanies.filter(a=>a.active);
  },
  getterActiveHospitals(state) {
    return state.hospitals.filter(a=>a.active);
  },
  getterActiveHealthInsurances(state) {
    return state.healthInsurances.filter(a=>a.active);
  },
  getterActiveChartOfAccounts(state) {
    return state.chartOfAccounts.filter(a=>a.active);
  },

};

/**
 *
 * @type {{filiais: *[], filiaisKey: {}, hospitals: *[], healthInsurances: *[], healthInsurancesKey: {}, adminCompaniesKey: {}, hospitalsKey: {}, usersKey: {}, users: *[], adminCompanies: *[]}}
 */
export const state = {
  hospitals: [],
  healthInsurances: [],
  users: [],
  filiais: [],
  adminCompanies: [],
  chartOfAccounts: [],

  hospitalsKey: {},
  healthInsurancesKey: {},
  usersKey: {},
  filiaisKey: {},
  adminCompaniesKey: {},
  chartOfAccountsKey: {},

//  cuteReason: [],
};

const traverseToDate = (root, obj, maxDeep=11) => {
  if(maxDeep<=0) {
    console.warn('traverseToDate atingiu o número máximo de profundidade', root);
    return;
  }
  for (const k in obj) {
    if (obj[k]) {
      if(typeof obj[k].toDate==='function') {
        obj[k] = obj[k].toDate();
      }
      else if(typeof obj[k] === 'object') {
        traverseToDate(root, obj[k], maxDeep-1);
      }
    }
  }
};

const traverseToFirestore = (root, obj, maxDeep=11) => {
  if(maxDeep<=0) {
    console.warn('traverseToFirestore atingiu o número máximo de profundidade', path, root);
    return;
  }
  for (const k in obj) {
    if (obj[k]) {
      if(obj[k] instanceof Date) {
        obj[k] = Timestamp.fromDate(obj[k]);
      }
      else if(typeof obj[k] === 'object') {
        traverseToFirestore(root, obj[k], maxDeep-1);
      }
    }
  }
};

// const traverseToFirestoreDebug = (root, obj, maxDeep=11, path = '') => {
//   if(maxDeep<=0) {
//     console.warn('traverseToFirestore atingiu o número máximo de profundidade', path, root);
//     return;
//   }
//   for (const k in obj) {
//     if (obj[k]) {
//       if(obj[k] instanceof Date) {
//         obj[k] = Timestamp.fromDate(obj[k]);
//       }
//       else if(typeof obj[k] === 'object') {
//         traverseToFirestore(root, obj[k], maxDeep-1, path+'/'+k);
//       }
//     }
//   }
// };

export const cacheLoadedObj = new FcmEvent(30000);
// export const cacheLoaded = cacheLoadedObj.promise;



export function getCacheLoaded() {
  return cacheLoadedObj.getPromise();
}

cacheLoadedObj.getPromise().then(()=>{
  console.log('CacheLoaded Loaded');
}).catch(()=>{});

// const fcmTimer = new FcmTimer();
// const fcmTimer = new FcmTimer('procedures');
// fcmTimer.start();


const FcmLocalCache = {
  APP: 'APP',
  COMPANY: 'COMPANY',
  USER: 'USER'
};
const FcmTypeCache = {
  DIRECT: 'DIRECT',
  FRAGMENT: 'FRAGMENT'
};
const FcmStatusCache = {
  STOPPED: 'STOPPED',
  RUNNING: 'RUNNING',
};

class FcmItemCache {
  local = FcmLocalCache.APP;
  status = FcmStatusCache.STOPPED;
  unsubscribe = null;
  name = null;
  ref= null;
  companyId = null;
  matrizId = null;
  filialHiddenMatrizData = false;
  preLoader = null;
  filter = null;
  beforePersist = null;
  /**
   *
   * @type FcmCacheController
   */
  fcmCacheController = null;
  isFirst= false;
  firstLoadResolve = null;
  firstLoadRejected = null;
  preRef = null;
  indexes = ['companyId'];
  startOnMatriz = false;
  startOnSuperAdmin = false;
  constructor({controller, name, collectionNameOrRef, local=FcmLocalCache.App, type=FcmTypeCache.DIRECT,
    preLoader=null, indexes = undefined, startOnMatriz = false, startOnSuperAdmin = false,
    beforePersist = null, filter = null}) {
    this.local = local;
    this.type = type;
    this.name = name;
    this.fcmCacheController = controller;
    this.beforePersist = beforePersist;
    this.filter = filter;
    if(typeof collectionNameOrRef==='string') {
      this.ref = firestore.collection(collectionNameOrRef);
    }
    else if(typeof collectionNameOrRef==='object') {
      this.ref = collectionNameOrRef;
    }
    else {
      console.error('FcmItemCache: collectionNameOrRef inválido');
      return;
    }
    if(preLoader) {
      this.preLoader = preLoader;
    }
    else {
      this.preLoader = function(item) {
        item.search = _.deburr(item.name||'').toLowerCase().trim();
        return item;
      };
    }
    if (indexes) {
      this.indexes = indexes;
    }
    this.startOnMatriz = !!startOnMatriz;
    this.startOnSuperAdmin = !!startOnSuperAdmin;
  }
  stop() {
    if(typeof this.unsubscribe === 'function') {
      this.unsubscribe();
      this.unsubscribe= null;
    }
    this.status = FcmStatusCache.STOPPED;
  }
  async clearCache() {
    await this.fcmCacheController.fcmIndexedDB.cleanStore(this.name);
  }
  async preStart(companyId=null, matrizId=null, filialHiddenMatrizData=false) {
    if (this.startOnMatriz && !this.fcmCacheController.company?.isMatriz) {
      return false;
    }
    if (this.startOnSuperAdmin && !this.fcmCacheController.isSuperAdminAccess) {
      return false;
    }
    let items = [];
    if(this.local===FcmLocalCache.COMPANY) {
      this.companyId = companyId;
      this.matrizId = matrizId;
      this.filialHiddenMatrizData = !!(this.matrizId && filialHiddenMatrizData);
      items = await this.fcmCacheController.fcmIndexedDB.getAllDataByCompany(this.name, this.companyId, filialHiddenMatrizData?null:this.matrizId);
      // if(this.filialHiddenMatrizData) {
      //   items.filter((a)=>a.companyId===this.companyId);
      // }
    }
    else {
      if(this.status === FcmStatusCache.RUNNING) {
        return false;
      }
      items = await this.fcmCacheController.fcmIndexedDB.getAllData(this.name);
    }
    //    fcmTimer.lap('FcmCacheController FcmItemCache start antes traverseToFirestore '+this.name, this.name);

    if(typeof this.preLoader==='function') {
      for(const i in items) {
        traverseToFirestore(items[i], items[i]);
        items[i] = this.preLoader(items[i]);
      }
    }
    else {
      for(const i in items) {
        traverseToFirestore(items[i], items[i]);
      }
    }
    //    fcmTimer.lap('FcmCacheController FcmItemCache start depois traverseToFirestore '+this.name, this.name);
    this.status = FcmStatusCache.RUNNING;

    let addItemsToStore = items;
    if(typeof this.filter==='function') {
      addItemsToStore = items.filter(this.filter);
    }
    this.fcmCacheController.store.commit('addItems', {values: addItemsToStore, cacheName: this.name});

    let greaterDate = {
      seconds: 0,
      nanoseconds: 0,
    };

    for(const p of items) {
      if(p?.meta?.updatedAt && (
        (p.meta.updatedAt.seconds===greaterDate.seconds && p.meta.updatedAt.nanoseconds>greaterDate.nanoseconds)
        ||(p.meta.updatedAt.seconds>greaterDate.seconds))) {
        greaterDate = p.meta.updatedAt;
      }
    }


    let ref = this.ref;
    if(this.name==='users') {
      if(this.matrizId && !this.filialHiddenMatrizData) {
        ref = ref.where('companyAndFiliaisIds', 'array-contains-any', [this.companyId, this.matrizId]);
      }
      else {
        ref = ref.where('companyAndFiliaisIds', 'array-contains-any', [this.companyId]);
      }
    }
    else if(this.name==='filiais') {
      ref = ref.where('matrizId', '==', this.companyId);
    }
    else if(this.local===FcmLocalCache.COMPANY) {
      if(this.matrizId && !this.filialHiddenMatrizData) {
        ref = ref.where('companyId', 'in', [this.companyId, this.matrizId]);
      }
      else {
        ref = ref.where('companyId', '==', this.companyId);
      }
    }
    if(process.env.NODE_ENV !== 'production' && LIMIT_CACHE_DEV) {
      ref = ref.limit(LIMIT_CACHE_DEV);
    }

    if(greaterDate.seconds>0) {
      // ref = ref.where('meta.updatedAt', '>', new Timestamp(greaterDate.seconds, greaterDate.nanoseconds)).orderBy('meta.updatedAt');
      ref = ref.orderBy('meta.updatedAt').startAfter(new Timestamp(greaterDate.seconds, greaterDate.nanoseconds));
    } else {
      console.log('Not found cache: '+this.name);
    }
    this.preRef = ref;

    if (!items?.length) {
      console.log('Cold start '+this.name);
      analytics?.logEvent('volanWebCacheColdStart', {
        value: 1,
        cacheName: this.name,
      });
    }

    return true;
  }
  async start(companyId=null, matrizId=null, filialHiddenMatrizData=false, startDelay=0) {
    if (this.startOnMatriz && !this.fcmCacheController.company?.isMatriz) {
      return;
    }
    if (this.startOnSuperAdmin && !this.fcmCacheController.isSuperAdminAccess) {
      return;
    }
    if(!this.preRef) {
      await this.preStart(companyId, matrizId, filialHiddenMatrizData);
    }
    if(!this.preRef) {
      return;
    }
    //    fcmTimer.lap('FcmCacheController FcmItemCache start antes firebase '+this.name, this.name);
    if(startDelay) {
      await delay(startDelay);
    }
    await new Promise((resolve, reject)=>{
      this.firstLoadResolve = resolve;
      this.firstLoadRejected = reject;
      this.isFirst = true;

      try {
        this.unsubscribe= this.preRef.onSnapshot(
          this.onSnapshot.bind(this),
          this.onSnapshotError.bind(this),
          this.onSnapshotConclude.bind(this)
        );
      } catch(err) {
        console.error('Erro ao ligar listener de cache', this.name, this, err);
      }

      this.preRef = null;
    });
    //    fcmTimer.lap('FcmCacheController FcmItemCache start end '+this.name, this.name);
  }
  async onSnapshotError(err) {
    console.error('Erro ao ligar listener de cache!', this.name, this, err);
  }
  async onSnapshotConclude() {
    console.log('conclude', this.name);
  }
  async onSnapshot(snapshot) {
    const addItems = [];
    // const removeItems = [];
    snapshot.docChanges().forEach((snap)=>{
      if (snap.type === 'added' || snap.type === 'modified') {
        let value = snap.doc.data();
        value.id = snap.doc.id;
        if(typeof this.preLoader==='function') {
          value = this.preLoader(value);
        }
        // if(value) {
        addItems.push(value);
        // }
        // else {
        //   removeItems.push({id: value.id});
        // }

      }
      else if (snap.type === 'removed') {  // Remove items removidos (Obs: removido !== de inativo)
        this.fcmCacheController.store.commit('removeItem', {value: {id: snap.doc.id}, cacheName: this.name});
        this.fcmCacheController.fcmIndexedDB.removeData(this.name, {id: snap.doc.id});
      }
      else {
        console.warn('Recebido dads estranhos do firebase', snap);
      }
    });

    if(addItems.length>0) {
      if(typeof this.beforePersist==='function') {
        for(const item of addItems) {
          this.beforePersist(item, addItems, this.fcmCacheController.store.state?.[this.name]);
        }
      }

      let addItemsToStore = addItems;
      if(typeof this.filter==='function') {
        addItemsToStore = addItems.filter(this.filter);
      }
      this.fcmCacheController.store.commit('addItems', {values: addItemsToStore, cacheName: this.name});
      //  fcmTimer.lap('FcmCacheController FcmItemCache start antes traverseToDate '+this.name, this.name+'_t');
      const addItemsIndexed = _.cloneDeep(addItems);
      traverseToDate(addItemsIndexed, addItemsIndexed);
      //  fcmTimer.lap('FcmCacheController FcmItemCache start depois traverseToDate '+this.name, this.name+'_t');
      await this.fcmCacheController.fcmIndexedDB.putData(this.name, addItemsIndexed);

      analytics?.logEvent('volanWebCacheItems', {
        cacheQtd: addItems.length,
        cacheName: this.name,
        starts: 1,
      });
    }

    // if(removeItems.length>0) { // Remover items inativos do IndexedDB
    //   await this.fcmCacheController.fcmIndexedDB.removeData(this.name, removeItems);
    // }


    if(this.isFirst) {
      this.isFirst = false;
      if(typeof this.firstLoadResolve ==='function') {
        this.firstLoadResolve();
      }
      this.firstLoadResolve = null;
      this.firstLoadRejected = null;
      if(this.local===FcmLocalCache.COMPANY) {
        console.log('resolve', this.name);
        cacheLoadedObj.resolve();
      }
      else {
        console.log('finish', this.name);
      }
    }
    else {
      // if(removeItems.length>0) { // Remove items inativos do vuex
      //   this.fcmCacheController.store.commit('removeItems', {values: removeItems, cacheName: this.name});
      // }
    }
  }
}

class FcmCacheController {
  store = null;
  /**
   *
   * @type {Object.<string, FcmItemCache>}
   */
  caches = {};
  companyId = null;
  matrizId = null;
  company = null;
  filialHiddenMatrizData = false;
  appCachesInitialized = false;
  fcmIndexedDB = null;
  userId = null;
  isSuperAdminAccess = false;
  constructor() {
    this.caches = {
      // surgeons: new FcmItemCache({
      //   controller: this,
      //   name: 'surgeons',
      //   collectionNameOrRef: 'company_cirurgioes',
      //   local: FcmLocalCache.COMPANY,
      //   preLoader: function(item) {
      //     item.search = _.deburr((item.name||'')+' '+(item.crm||'')).toLowerCase().trim();
      //     return item;
      //   }
      // }),
      // anesthetists: new FcmItemCache({
      //   controller: this,
      //   name: 'anesthetists',
      //   // collectionNameOrRef: firestore.collection('company_users').where('is_anestesista', '==', true),
      //   collectionNameOrRef: firestore.collection('company_users'),
      //   local: FcmLocalCache.COMPANY,
      //   preLoader: (item) => {
      //     let isAnesthetist = !!item.userTypes?.[this.companyId]?.find((a)=>(a===UserType.ANESTHETIST));
      //     let isResident = !!item.userTypes?.[this.companyId]?.find((a)=>(a===UserType.RESIDENT));
      //
      //     let active = item.companyUser?.[this.companyId]?.active || false;
      //     item.search = _.deburr((item.name||'')+' '+(item.crm||'')+ ' '+ (item.sigla||'')).toLowerCase().trim();
      //     if(this.company?.isMatriz) {
      //       if(!isAnesthetist) {
      //         for(const companyId in item.userTypes || {}) {
      //           if(this.company?.filiaisIds?.includes?.(companyId) && item.userTypes[companyId]?.find((a)=>(a===UserType.ANESTHETIST))) {
      //             isAnesthetist = true;
      //             break;
      //           }
      //         }
      //       }
      //       if(!isResident) {
      //         for(const companyId in item.userTypes || {}) {
      //           if(this.company?.filiaisIds?.includes?.(companyId) && item.userTypes[companyId]?.find((a)=>(a===UserType.RESIDENT))) {
      //             isResident = true;
      //             break;
      //           }
      //         }
      //       }
      //       if(!active) {
      //         for(const companyId in item.companyUser || {}) {
      //           if(this.company?.filiaisIds?.includes?.(companyId) && item.companyUser[companyId]?.active) {
      //             active = true;
      //             break;
      //           }
      //         }
      //       }
      //     }
      //     item._isAnesthetist = isAnesthetist;
      //     item._isResident = isResident;
      //     item._active = active;
      //     return item;
      //   }
      // }),
      healthInsurances: new FcmItemCache({
        controller: this,
        name: 'healthInsurances',
        collectionNameOrRef: 'healthInsurances',
        local: FcmLocalCache.COMPANY
      }),
      hospitals: new FcmItemCache({
        controller: this,
        name: 'hospitals',
        collectionNameOrRef: 'company_hospitais',
        local: FcmLocalCache.COMPANY
      }),
      chartOfAccounts: new FcmItemCache({
        controller: this,
        name: 'chartOfAccounts',
        collectionNameOrRef: 'chartOfAccounts',
        local: FcmLocalCache.COMPANY,
        preLoader: (item) => {
          item.search = getSearch([item.name, item.codCT]);
          return item;
        },
        // Cada empresa (matriz OU filial) tem o SEU próprio plano de contas — não herda o da matriz.
        // O cache COMPANY pode trazer docs da matriz para o IndexedDB; o filtro os retira do store.
        filter: (item) => item.companyId === this.companyId,
      }),
      users: new FcmItemCache({
        controller: this,
        name: 'users',
        collectionNameOrRef: 'users',
        local: FcmLocalCache.COMPANY,
        indexes: ['_companyId'],
        preLoader: (item) => {
          item._companyId = this.companyId;
          item._companyUser = item.companiesUser[this.companyId] || {};
          if (this.matrizId) {
            item._companyUserMatriz = item.companiesUser[this.matrizId] || {};
          }
          else {
            item._companyUserMatriz = {};
          }

          const searchList = [item.name, item._companyUser.acronym, item._companyUserMatriz.acronym,
            item.email, item.id, item.document];
          item._boardInfo = '';
          for (const ub of item._companyUser.userBoardInfos || []) {
            searchList.push(ub.boardNumber);
            item._boardInfo += `${ub.boardNumber} ${ub.region} `;
          }
          for (const ub of item._companyUserMatriz.userBoardInfos || []) {
            searchList.push(ub.boardNumber);
            item._boardInfo += `${ub.boardNumber} ${ub.region} `;
          }
          item.search = getSearch(searchList);
          return item;
        },
        // filter: (item) => {
        //   return true;
        // }
      }),
      filiais: new FcmItemCache({
        controller: this,
        name: 'filiais',
        startOnMatriz: true,
        collectionNameOrRef: 'companies',
        local: FcmLocalCache.COMPANY,
        indexes: ['companyId', 'matrizId'],
        preLoader: (item) => {
          item.search = getSearch([item.name, item.cnpj]);
          return item;
        }
      }),
      adminCompanies: new FcmItemCache({
        controller: this,
        name: 'adminCompanies',
        startOnSuperAdmin: true,
        collectionNameOrRef: 'companies',
        local: FcmLocalCache.USER,
        preLoader: (item) => {
          item.search = getSearch([item.name, item.cnpj, item.nickName, item.id]);
          return item;
        },
      }),
    };
    this.initBD();
    if(process.env.NODE_ENV !== 'production') {
      // console.log('Cache de apenas '+LIMIT_CACHE_DEV+' itens de cada cache em desenvolvimento');
    }
    // let count = 0;
    // for(const i in this.caches) {
    //   if(this.caches[i].local===FcmLocalCache.COMPANY) {
    //     count++;
    //   }
    // }
    // cacheLoadedObj.setCountResolve(count);
  }
  initBD() {
    this.fcmIndexedDB = new FcmIndexedDB('FcmJwCacheController', CACHE_DB_VERSION, this.caches);
  }
  init(store) {
    this.store = store;
  }
  async clearCaches() {
    console.log('clearCaches');
    for(const i in this.caches) {
      await this.caches[i].clearCache();
    }
  }
  async clearCachesCompanies() {
    await this.store.commit('initCompany');
    console.log('clearCaches');
    for(const i in this.caches) {
      if(this.caches[i].local===FcmLocalCache.COMPANY) {
        await this.caches[i].clearCache();
      }
    }

  }
  async startCompanyCaches(companyId, matrizId=null, filialHiddenMatrizData=false, company=null) {
    console.log('startCompanyCaches');
    if(!matrizId && filialHiddenMatrizData) {
      this.filialHiddenMatrizData = false;
      console.warn('Inconsistência encontrada !matrizId and filialHiddenMatrizData');
    }
    this.company = company;
    if(this.companyId===companyId && this.matrizId===matrizId && this.filialHiddenMatrizData===filialHiddenMatrizData) {
      console.log('same company');
      return;
    }
    if(this.companyId) {
      cacheLoadedObj.startTimer();
    }
    //    fcmTimer.lap('FcmCacheController startCompanyCaches ini', 'startCompanyCaches');
    this.stopItemCaches(FcmLocalCache.COMPANY);
    if(this.companyId || this.matrizId) {
      await this.clearCachesCompanies();
    }
    this.companyId = companyId;
    this.matrizId = matrizId;
    this.filialHiddenMatrizData = filialHiddenMatrizData;

    await this.fcmIndexedDB.putData('config', {
      id: 'config',
      date: new Date(),
      companyId,
      matrizId,
      filialHiddenMatrizData,
      isMatriz: this.company?.isMatriz || false
    });


    const promises = [];
    if(this.companyId)  {
      for(const i in this.caches) {
        if(this.caches[i].local===FcmLocalCache.COMPANY) {
          promises.push(this.caches[i].preStart(this.companyId, this.matrizId, this.filialHiddenMatrizData));
        }
      }
      const resultCachesPreStart = await Promise.all(promises);
      let count = 0;
      for(const result of resultCachesPreStart) {
        if(result) {
          count++;
        }
      }
      cacheLoadedObj.setCountResolve(count);

      //      fcmTimer.lap('FcmCacheController startCompanyCaches finish precaches', 'startCompanyCaches');
      for(const i in this.caches) {
        if(this.caches[i].local===FcmLocalCache.COMPANY) {
          await this.caches[i].start(this.companyId, this.matrizId, this.filialHiddenMatrizData);
        }
      }

    }

    //    fcmTimer.lap('FcmCacheController startCompanyCaches end', 'startCompanyCaches');
  }
  async startAppCaches() {
    if(this.appCachesInitialized) {
      return;
    }
    this.stopAppCaches();
    cacheLoadedObj.startTimer();
    for(const i in this.caches) {
      if(this.caches[i].local===FcmLocalCache.APP) {
        await this.caches[i].start();
      }
    }
  }
  stopAppCaches() {
    if(this.appCachesInitialized) {
      return;
    }
    this.stopItemCaches(FcmLocalCache.APP);
    this.appCachesInitialized = true;
    this.store.commit('initApp');
  }
  stopItemCaches(local) {
    for(const i in this.caches) {
      if(this.caches[i].local===local) {
        this.caches[i].stop();
      }
    }
  }

  async startUserCaches(userId=null, isSuperAdminAccess=false) {
    if(this.userId===userId && this.isSuperAdminAccess===isSuperAdminAccess) {
      return;
    }
    // await this.stopUserCaches();
    this.userId = userId;
    this.isSuperAdminAccess = isSuperAdminAccess;
    this.stopItemCaches(FcmLocalCache.USER);
    for(const i in this.caches) {
      if(this.caches[i].local===FcmLocalCache.USER) {
        await this.caches[i].start();
      }
    }
  }
  // async stopUserCaches() {
  //   this.stopItemCaches(FcmLocalCache.USER);
  //   for(const i in this.caches) {
  //     if(this.caches[i].local===FcmLocalCache.USER) {
  //       await this.caches[i].clearCache();
  //     }
  //   }
  //   this.userId = null;
  //   this.isSuperAdminAccess = false;
  //   this.store.commit('initUser');
  // }
}

const cacheController = new FcmCacheController();


export const actions = {
  init(store) {
    store.commit('initApp');
    store.commit('initCompany');
    cacheController.init(store);
    eventHub.on('auth:changeCompany', (arg)=>{
      store.dispatch('changeCompany', arg);
    });
    eventHub.on('auth:changeUser', (arg)=>{
      store.dispatch('changeUser', arg);
    });
  },
  /**
   * @deprecated Foi alterada a forma como os procedimentos são carregados
   * @returns {Promise<void>}
   */
  async tryInitProcedures({ commit }) {
    await delay(500);
    // await cacheController.caches.procedures?.start(null, null, 500);
    // await cacheController.caches.cuteReason.start();
  },
  async changeCompany({ commit, rootState }) {
    const companyId = rootState?.auth?.currentCompanyId;
    const matrizId = rootState?.auth?.currentCompanyMatrizId;
    const filialHiddenMatrizData = rootState?.auth?.currentCompany?.flags?.filialHiddenMatrizData || false;
    if(companyId===null) {
      // await cacheController.clearCachesCompanies();
      await cacheController.startCompanyCaches(null, null, false, null);
    }
    else {
      await cacheController.startCompanyCaches(companyId, matrizId, filialHiddenMatrizData, rootState?.auth?.currentCompany);
    }
    return 0;
  },
  async changeUser({rootState}) {
    await cacheController.startUserCaches(rootState?.auth?.currentUser?.id || null,
      (rootState?.auth?.isSuperAdminAccess || rootState?.auth?.currentWorkspace==='ADMIN' || false));
  },

  stopCache({ commit }) {
    commit('initCompany');
    commit('initApp');
    commit('initUser');
  },
  cacheLoaded({state}) {

    return true;
  }
};

export const mutations = {
  initCompany(state) {
    state.hospitals = [];
    state.healthInsurances = [];
    state.users = [];
    state.filiais = [];
    state.chartOfAccounts = [];

    state.hospitalsKey = {};
    state.healthInsurancesKey = {};
    state.usersKey = {};
    state.filiaisKey = {};
    state.chartOfAccountsKey = {};
  },
  initApp(state) {
    state.procedures = [];
    //    state.cuteReason = [];
  },
  initUser(state) {
    state.adminCompanies = [];
    state.adminCompaniesKey = {};
    //    state.cuteReason = [];
  },
  addItem(state, {value, cacheName}) {
    const c = state[cacheName];
    state[cacheName+'Key'][value.id] = value;
    const key = c.findIndex((a)=>a.id===value.id);
    if(key>=0) {
      c.splice(key, 1, value);
    }
    else {
      const key2 = c.findIndex((a)=>a.search>value.search);
      if(key2>0) {
        c.splice(key2-1, 0, value);
      }
      else {
        c.push(value);
      }
    }
  },
  addItems(state, {values, cacheName}) {
    const c = state[cacheName];
    if(c.length===0) {
      values.sort(function(a, b) {
        if (a.search > b.search) {
          return 1;
        }
        if (a.search < b.search) {
          return -1;
        }
        return 0;
      });
      const keyMap = {};
      for(const value of values) {
        keyMap[value.id] = value;
      }
      // for(const value of values) { // fazer dessa forma é muito, muito lento
      //   c.push(value);
      // }
      state[cacheName] = values;
      state[cacheName+'Key'] = keyMap;
    }
    else if(values?.length>5) { // Melhorar desempenho quando houver muitos itens atualizados
      const cNew = c.slice();
      for(const value of values) {
        const key = cNew.findIndex((a)=>a.id===value.id);
        if(key>=0) {
          cNew.splice(key, 1, value);
        }
        else {
          const key2 = cNew.findIndex((a)=>a.search>value.search);
          if(key2>0) {
            cNew.splice(key2-1, 0, value);
          }
          else {
            cNew.push(value);
          }
        }
      }
      const keyMap = {};
      for(const value of cNew) {
        keyMap[value.id] = value;
      }
      state[cacheName] = cNew;
      state[cacheName+'Key'] = keyMap;
    }
    else {
      for(const value of values) {
        const key = c.findIndex((a)=>a.id===value.id);
        if(key>=0) {
          c.splice(key, 1, value);
        }
        else {
          const key2 = c.findIndex((a)=>a.search>value.search);
          if(key2>0) {
            c.splice(key2-1, 0, value);
          }
          else {
            c.push(value);
          }
        }
        state[cacheName+'Key'][value.id] = value;
      }
    }
  },

  addItemNotSort(state, {value, cacheName}) {
    const c = state[cacheName];
    const key = c.findIndex((a)=>a.id===value.id);
    if(key>=0) {
      c.splice(key, 1, value);
    }
    else {
      c.push(value);
    }
  },
  addItemsNotSort(state, {values, cacheName}) {
    const c = state[cacheName];
    if(c.length===0) {
      for(const value of values) {
        c.push(value);
      }
    }
    else {
      for(const value of values) {
        const key = c.findIndex((a)=>a.id===value.id);
        if(key>=0) {
          c.splice(key, 1, value);
        }
        else {
          c.push(value);
        }
      }
    }

  },
  removeItems(state, {values, cacheName}) {
    for(const value of values) {
      const key = state[cacheName].findIndex((a) => a.id === value.id);
      if (key >= 0) {
        state[cacheName].splice(key, 1);
      }
      delete state[cacheName+'Key'][value.id];
    }
  },

  removeItem(state, {value, cacheName}) {
    const key = state[cacheName].findIndex((a)=>a.id===value.id);
    if(key>=0) {
      state[cacheName].splice(key, 1);
    }
    delete state[cacheName+'Key'][value.id];
  },
};
